import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { TransactionExtendedStore } from './transaction-extended.store';
import { TransactionExtended, TransactionExtendedItem } from './transaction.extended.model';
import { EMPTY, Observable } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';
import { ApiService } from '../../shared/services/core/api.service';
import { TransactionExtendedQuery } from './transaction-extended.query';

@Injectable({ providedIn: 'root' })
export class TransactionExtendedService{

    constructor(private transactionExtendedStore: TransactionExtendedStore,
                private transactionExtendedQuery: TransactionExtendedQuery,
                private api: ApiService){
    }

    getExtendedTransactions(purseNumber: number, dateFrom: Date, dateTo: Date, pageNumber: number, pageSize: number): Observable<TransactionExtended[]>{
        const fromDate = encodeURI(formatDate(dateFrom, 'yyyy-MM-dd', 'en-GB'));
        const toDate = formatDate(dateTo, 'yyyy-MM-dd', 'en-GB');
        return this.api.get<TransactionExtended>(`purse/transactions/extended/${purseNumber}/${fromDate}/${toDate}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
    }

    getTransactionDetailsByTref(tref: number): Observable<TransactionExtendedItem[]>{
        return this.api.get<TransactionExtendedItem>(`purse/transactions/extended/item/${tref}`);
    }

    search(purseNumber: number, dateFrom: Date, dateTo: Date, pageNumber: number, pageSize: number): Observable<TransactionExtended[]>{
        this.transactionExtendedStore.setLoading(true);
        return this.getExtendedTransactions(purseNumber, dateFrom, dateTo, pageNumber, pageSize)
        .pipe(
            tap(entities => this.transactionExtendedStore.add(entities)),
            finalize(() => this.transactionExtendedStore.setLoading(false))
        );
    }

    loadItemDetailsByTref(tref: number): Observable<TransactionExtendedItem[] | undefined>{
        if( this.transactionExtendedQuery.hasActive(tref) ){
            if( !this.transactionExtendedQuery.hasItemDetails(tref) ){
                this.transactionExtendedStore.setUILoading(tref, true);
                return this.getTransactionDetailsByTref(tref)
                .pipe(
                    tap((response: any) =>{
                    if( response.ErrorCode === 'S' ){
                        this.transactionExtendedStore.setItemDetails(tref, response.Data);
                    }
                    }),
                    finalize(() => this.transactionExtendedStore.setUILoading(tref, false))
                );
            }
            // err { Code: "Purse.CODE.3412", Message: null
        return this.transactionExtendedQuery.getItemDetailsByTref(tref);
        }
        return EMPTY;
    }

    toggleActive(id: number): void{
        this.transactionExtendedStore.toggleActive(id);
    }

    reset(): void{
        this.transactionExtendedStore.restoreDefaults();
    }
}